"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XDRBuilder = void 0;

var constants_1 = require("../constants");

var stellar_sdk_1 = require("stellar-sdk");

var axios_1 = __importDefault(require("axios"));
/**
 * Holds the functions to generate Niftron Specific XDR
 */


var XDRBuilder;

(function (XDRBuilder) {
  var _this = this;

  var merchantKeypair;

  XDRBuilder.initialize = function (secretKey) {
    merchantKeypair = stellar_sdk_1.Keypair.fromSecret(secretKey);
  };
  /**
   * Build Add Niftron Signer XDR
   * @param {string} primaryPublicKey string
   * @returns {XDRBuilderResponse} builderResponse XDRBuilderResponse
   */


  XDRBuilder.register = function (primaryPublicKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, secondaryPublicKey, err_1;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            postBody = {
              primaryPublicKey: primaryPublicKey,
              merchantPublicKey: merchantKeypair.publicKey()
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/xdrBuilder/register", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _b.sent();

            if (res === null) {
              throw Error("failed to build register xdr");
            }

            xdrs = res.data.data;
            secondaryPublicKey = (_a = res.data.metaData) === null || _a === void 0 ? void 0 : _a.secondaryPublicKey;
            return [2
            /*return*/
            , {
              xdrs: xdrs,
              secondaryPublicKey: secondaryPublicKey
            }];

          case 2:
            err_1 = _b.sent();
            throw err_1;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * signXDR
   * @param {string} xdr string
   * @param {string} secretKey string
   * @returns {any} transactionResponse any
   */


  XDRBuilder.signXDR = function (xdr, secretKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var parsedTx, publicKey, server, keypair, sourceAccount, err_2, err2_1, x, err_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 9,, 10]);

            parsedTx = void 0;
            publicKey = void 0;
            server = new stellar_sdk_1.Server(constants_1.StellarUrl);
            keypair = stellar_sdk_1.Keypair.fromSecret(secretKey);
            sourceAccount = void 0;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 8]);

            parsedTx = new stellar_sdk_1.Transaction(xdr, stellar_sdk_1.Networks.PUBLIC);
            publicKey = parsedTx.source;
            return [4
            /*yield*/
            , server.loadAccount(keypair.publicKey())];

          case 2:
            sourceAccount = _a.sent();
            return [3
            /*break*/
            , 8];

          case 3:
            err_2 = _a.sent();
            _a.label = 4;

          case 4:
            _a.trys.push([4, 6,, 7]);

            server = new stellar_sdk_1.Server(constants_1.StellarUrlTest);
            parsedTx = new stellar_sdk_1.Transaction(xdr, stellar_sdk_1.Networks.TESTNET);
            publicKey = parsedTx.source;
            return [4
            /*yield*/
            , server.loadAccount(keypair.publicKey())];

          case 5:
            sourceAccount = _a.sent();
            return [3
            /*break*/
            , 7];

          case 6:
            err2_1 = _a.sent();
            throw err2_1;

          case 7:
            return [3
            /*break*/
            , 8];

          case 8:
            parsedTx.sign(keypair);
            x = parsedTx.toEnvelope().toXDR().toString("base64");
            return [2
            /*return*/
            , x];

          case 9:
            err_3 = _a.sent();
            console.log(err_3);
            throw err_3;

          case 10:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Build Mint Certificate XDR
   * @param {string} tokenName string
   * @param {string} tokenType string
   * @param {boolean} tradable boolean
   * @param {boolean} transferable boolean
   * @param {boolean} authorizable boolean
   * @param {string} creator string
   * @param {number} assetCount number
   * @param {string} dataHash string
   * @returns {XDRBuilderResponse} builderResponse XDRBuilderResponse
   */


  XDRBuilder.mintCertificate = function (tokenName, tokenType, tradable, transferable, authorizable, creator, assetCount, dataHash) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, niftronId, err_4;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            postBody = {
              tokenName: tokenName,
              tokenType: tokenType,
              tradable: tradable,
              transferable: transferable,
              authorizable: authorizable,
              primaryPublicKey: creator,
              merchantPublicKey: merchantKeypair.publicKey(),
              assetCount: assetCount,
              dataHash: dataHash
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/mint/certificate", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _b.sent();

            if (res === null) {
              throw Error("failed to build mint certificate xdr");
            }

            xdrs = res.data.data;
            niftronId = (_a = res.data.metaData) === null || _a === void 0 ? void 0 : _a.niftronId;
            return [2
            /*return*/
            , {
              xdrs: xdrs,
              niftronId: niftronId
            }];

          case 2:
            err_4 = _b.sent();
            throw err_4;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Build Transfer Certificate XDR
   * @param {string} sender string
   * @param {string} receiver string
   * @param {string} assetIssuer string
   * @param {string} assetCode string
   * @param {string} assetCount string
   * @param {Array<string>} approvers Array<string>
   * @param {Date} minTime Date
   * @param {Date} maxTime Date
   * @returns {TransferCertificateXDR} transferCertificateXDR TransferCertificateXDR
   */


  XDRBuilder.transferCertificate = function (sender, receiver, assetIssuer, assetCode, assetCount, approvers, minTime, maxTime) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, err_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              sender: sender,
              receiver: receiver,
              merchant: merchantKeypair.publicKey(),
              assetIssuer: assetIssuer,
              assetCode: assetCode,
              assetCount: assetCount,
              approvers: approvers,
              minTime: minTime,
              maxTime: maxTime
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/transfer/certificate", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build transfer certificate xdr");
            }

            xdrs = res.data.data; // const secondaryPublicKey = res.data.metaData?.secondaryPublicKey

            return [2
            /*return*/
            , {
              xdrs: xdrs
            }];

          case 2:
            err_5 = _a.sent();
            throw err_5;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Build Mint Badge XDR
  * @param {string} tokenName string
  * @param {string} tokenType string
  * @param {boolean} tradable boolean
  * @param {boolean} transferable boolean
  * @param {boolean} authorizable boolean
  * @param {string} creator string
  * @param {number} assetCount number
  * @param {string} dataHash string
  * @returns {XDRBuilderResponse} builderResponse XDRBuilderResponse
  */


  XDRBuilder.mintBadge = function (tokenName, tokenType, tradable, transferable, authorizable, creator, assetCount, dataHash) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, niftronId, err_6;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            postBody = {
              tokenName: tokenName,
              tokenType: tokenType,
              tradable: tradable,
              transferable: transferable,
              authorizable: authorizable,
              primaryPublicKey: creator,
              merchantPublicKey: merchantKeypair.publicKey(),
              assetCount: assetCount,
              dataHash: dataHash
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/mint/badge", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _b.sent();

            if (res === null) {
              throw Error("failed to build mint badge xdr");
            }

            xdrs = res.data.data;
            niftronId = (_a = res.data.metaData) === null || _a === void 0 ? void 0 : _a.niftronId;
            return [2
            /*return*/
            , {
              xdrs: xdrs,
              niftronId: niftronId
            }];

          case 2:
            err_6 = _b.sent();
            throw err_6;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Build Transfer Badge XDR
   * @param {string} sender string
   * @param {string} receiver string
   * @param {string} assetIssuer string
   * @param {string} assetCode string
   * @param {string} assetCount string
   * @param {Array<string>} approvers Array<string>
   * @param {Date} minTime Date
   * @param {Date} maxTime Date
   * @returns {TransferCertificateXDR} transferCertificateXDR TransferCertificateXDR
   */


  XDRBuilder.transferBadge = function (sender, receiver, assetIssuer, assetCode, assetCount, approvers, minTime, maxTime) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, err_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              sender: sender,
              receiver: receiver,
              merchant: merchantKeypair.publicKey(),
              assetIssuer: assetIssuer,
              assetCode: assetCode,
              assetCount: assetCount,
              approvers: approvers,
              minTime: minTime,
              maxTime: maxTime
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/transfer/badge", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build transfer badge xdr");
            }

            xdrs = res.data.data; // const secondaryPublicKey = res.data.metaData?.secondaryPublicKey

            return [2
            /*return*/
            , {
              xdrs: xdrs
            }];

          case 2:
            err_7 = _a.sent();
            throw err_7;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Build Mint GiftCard XDR
   * @param {string} tokenName string
   * @param {string} tokenType string
   * @param {boolean} tradable boolean
   * @param {boolean} transferable boolean
   * @param {boolean} authorizable boolean
   * @param {string} creator string
   * @param {number} assetCount number
   * @param {string} dataHash string
   * @returns {XDRBuilderResponse} builderResponse XDRBuilderResponse
   */


  XDRBuilder.mintGiftCard = function (tokenName, tokenType, tradable, transferable, authorizable, creator, assetCount, dataHash) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, niftronId, err_8;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            postBody = {
              tokenName: tokenName,
              tokenType: tokenType,
              tradable: tradable,
              transferable: transferable,
              authorizable: authorizable,
              primaryPublicKey: creator,
              merchantPublicKey: merchantKeypair.publicKey(),
              assetCount: assetCount,
              dataHash: dataHash
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/mint/giftcard", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _b.sent();

            if (res === null) {
              throw Error("failed to build mint badge xdr");
            }

            xdrs = res.data.data;
            niftronId = (_a = res.data.metaData) === null || _a === void 0 ? void 0 : _a.niftronId;
            return [2
            /*return*/
            , {
              xdrs: xdrs,
              niftronId: niftronId
            }];

          case 2:
            err_8 = _b.sent();
            throw err_8;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Build Transfer GiftCard XDR
   * @param {string} sender string
   * @param {string} receiver string
   * @param {string} assetIssuer string
   * @param {string} assetCode string
   * @param {string} assetCount string
   * @param {Array<string>} approvers Array<string>
   * @param {Date} minTime Date
   * @param {Date} maxTime Date
   * @returns {TransferCertificateXDR} transferCertificateXDR TransferCertificateXDR
   */


  XDRBuilder.transferGiftCard = function (sender, receiver, assetIssuer, assetCode, assetCount, approvers, minTime, maxTime) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, err_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              sender: sender,
              receiver: receiver,
              merchant: merchantKeypair.publicKey(),
              assetIssuer: assetIssuer,
              assetCode: assetCode,
              assetCount: assetCount,
              approvers: approvers,
              minTime: minTime,
              maxTime: maxTime
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/transfer/giftcard", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build transfer badge xdr");
            }

            xdrs = res.data.data; // const secondaryPublicKey = res.data.metaData?.secondaryPublicKey

            return [2
            /*return*/
            , {
              xdrs: xdrs
            }];

          case 2:
            err_9 = _a.sent();
            throw err_9;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Build Go Live XDR
  * @param {string} userPublicKey string
  * @param {string} merchantPublicKey string
  * @returns {string} activateXdr string
  */


  XDRBuilder.goLive = function (userPublicKey, merchantPublicKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdr, err_10;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              userPublicKey: userPublicKey,
              merchantPublicKey: merchantPublicKey
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/xdrBuilder/goLive", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("Failed to build go live xdr");
            }

            switch (res.data.code) {
              case 201:
                throw new Error("Merchant not found");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("User account not found");

              case 204:
                throw new Error("User account is already live");

              case 400:
                throw new Error("Failed to build go live xdr");
            }

            xdr = res.data.data;
            return [2
            /*return*/
            , xdr];

          case 2:
            err_10 = _a.sent();
            throw err_10;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Build Activate XDR
  * @param {string} userPublicKey string
  * @param {string} merchantPublicKey string
  * @returns {string} activateXdr string
  */


  XDRBuilder.activate = function (userPublicKey, merchantPublicKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdr, err_11;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              userPublicKey: userPublicKey,
              merchantPublicKey: merchantPublicKey
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/xdrBuilder/activate", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build activate xdr");
            }

            switch (res.data.code) {
              case 201:
                throw new Error("Merchant not found");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("User account not found");

              case 204:
                throw new Error("User account is not live");

              case 400:
                throw new Error("Failed to build activate xdr");
            }

            xdr = res.data.data;
            return [2
            /*return*/
            , xdr];

          case 2:
            err_11 = _a.sent();
            throw err_11;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Build Express Transfer XDR
  * @param {string} sender string
  * @param {string} receiver string
  * @param {string} assetIssuer string
  * @param {string} assetCode string
  * @param {string} assetCount string
  * @returns {Object<Array<XDR>>} xdrs Object<Array<XDR>>
  */


  XDRBuilder.expressTransfer = function (sender, receiver, assetIssuer, assetCode, assetCount) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, err_12;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              sender: sender,
              receiver: receiver,
              merchant: merchantKeypair.publicKey(),
              assetIssuer: assetIssuer,
              assetCode: assetCode,
              assetCount: assetCount
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/expressTransfer/token", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build express transfer xdr");
            }

            xdrs = res.data.data; // const secondaryPublicKey = res.data.metaData?.secondaryPublicKey

            return [2
            /*return*/
            , {
              xdrs: xdrs
            }];

          case 2:
            err_12 = _a.sent();
            throw err_12;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Build Trust XDR
  * @param {string} truster string
  * @param {string} assetIssuer string
  * @param {string} assetCode string
  * @returns {Object<Array<XDR>>} xdrs Object<Array<XDR>>
  */


  XDRBuilder.trust = function (truster, assetIssuer, assetCode) {
    return __awaiter(_this, void 0, void 0, function () {
      var postBody, res, xdrs, err_13;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            postBody = {
              truster: truster,
              merchant: merchantKeypair.publicKey(),
              assetIssuer: assetIssuer,
              assetCode: assetCode
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronTokenLambda + "/xdrBuilder/trust", postBody, {
              headers: {
                "Content-Type": "application/json"
              }
            })];

          case 1:
            res = _a.sent();

            if (res === null) {
              throw Error("failed to build trust xdr");
            }

            xdrs = res.data.data; // const secondaryPublicKey = res.data.metaData?.secondaryPublicKey

            return [2
            /*return*/
            , {
              xdrs: xdrs
            }];

          case 2:
            err_13 = _a.sent();
            throw err_13;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
})(XDRBuilder = exports.XDRBuilder || (exports.XDRBuilder = {}));